import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NbDialogRef, NbToastrService } from '@nebular/theme';
import { User } from 'src/app/models/users.model';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-add-promotion',
  templateUrl: './add-promotion.component.html',
  styleUrls: ['./add-promotion.component.scss'],
})
export class AddPromotionComponent implements OnInit {
  @Input() user: User;

  formData: {
    code: string;
  } = {
    code: null,
  };

  loading = false;

  constructor(
    private toastr: NbToastrService,
    protected dialogRef: NbDialogRef<AddPromotionComponent>,
    private http: HttpClient,
  ) {}

  async ngOnInit() {}

  async onSubmit(form: NgForm) {
    this.loading = true;
    await this.validateForm(form);
    if (form.invalid) {
      this.loading = false;
      return;
    }

    try {
      await this.addPromotionToUser(this.formData.code, form);
      this.dialogRef.close();
    } catch (error) {
      this.toastr.warning(error.message || error, 'Oops ...');
      console.error(error);
    }
    this.loading = false;
  }

  async addPromotionToUser(promotionCode: string, form: NgForm) {
    try {
      const data = (await this.http
        .post(`${environment.functionsRootUrl}/promotions-addPromotionToUser/`, { promotionCode: promotionCode, userUid: this.user.uid })
        .toPromise()) as { credits: number };

      this.toastr.success(`${data.credits} credits have been added`, 'Promotion applied!', {
        duration: 6000,
      });
    } catch (error) {
      if (error.status === 400) {
        form.controls['code'].setErrors({ invalid: true });
        this.toastr.warning(error.error, 'Invalid Promotion Code');
        return;
      }
      this.toastr.warning(error.error || error.message || error, 'Oops ...');
    }
  }

  async validateForm(form: NgForm) {
    await this.checkCoupon(this.formData.code).catch((e) => {
      if (e.status === 400) {
        form.controls['code'].setErrors({ invalid: true });
        this.toastr.warning(e.error, 'Invalid Promotion Code');
        return;
      }
      this.toastr.warning(e.error || e.message || e, 'Oops ...');
    });
  }

  checkCoupon(promotionCode: string) {
    return this.http.post(`${environment.functionsRootUrl}/promotions-checkPromotion/`, { promotionCode: promotionCode }).toPromise();
  }
}
